import { connect } from 'react-redux';
import { getFlags } from '../../redux/flags/selectors';
import { getThemeSkin, getPageThumb, getSeoCanonical, getIsMobile, getSeoTitle, getSeoDescription, getIsIOS, } from '../../publicSession/selectors';
import { getChatNewMessageArrived } from '../../ChatV2/redux/selectors';
var mapStateToProps = function (state) { return ({
    flags: getFlags(state),
    isMobile: getIsMobile(state),
    isIOS: getIsIOS(state),
    themeSkin: getThemeSkin(state),
    pageThumb: getPageThumb(state),
    pageUrl: getSeoCanonical(state),
    pageTitle: getSeoTitle(state),
    pageDescription: getSeoDescription(state),
    hasNewChatMessage: getChatNewMessageArrived(state),
}); };
export default connect(mapStateToProps);
//# sourceMappingURL=Head.container.js.map